import { c as _c } from "react/compiler-runtime";
import { ExperienceHeader } from "@/components/section/journey/ExperienceHeader";
import { cn } from "@/utils/helpers";
import { ExperienceEntry } from "@/utils/interfaces";
interface ExperienceCardProps {
  experience: ExperienceEntry;
  isActive: boolean;
  onClick: () => void;
}
const BASE_CARD_STYLES = "glass border-none p-4 rounded-4xl cursor-pointer transition-[opacity,box-shadow] duration-300 min-h-[7rem]";
const getCardStyles = (isActive: boolean) => cn(BASE_CARD_STYLES, isActive ? "glow" : "opacity-85 hover:opacity-100");
export const ExperienceCard = t0 => {
  const $ = _c(12);
  const {
    experience,
    isActive,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = getCardStyles(isActive);
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isActive || undefined;
  const t3 = `${experience.title} at ${experience.company}`;
  let t4;
  if ($[2] !== experience) {
    t4 = <ExperienceHeader experience={experience} size="sm" />;
    $[2] = experience;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClick || $[5] !== t3 || $[6] !== t4) {
    t5 = <button type="button" onClick={onClick} className="w-full text-left cursor-pointer" aria-label={t3}>{t4}</button>;
    $[4] = onClick;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t5) {
    t6 = <article role="listitem" className={t1} aria-current={t2}>{t5}</article>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};